import { useLocalStorage } from '@uidotdev/usehooks';
import { useEffect } from 'react';

export type ToggleTheme = React.Dispatch<React.SetStateAction<boolean>>;

const useDarkMode = (): [
  boolean,
  React.Dispatch<React.SetStateAction<boolean>>,
] => {
  const [isDarkTheme, toggleTheme] = useLocalStorage('theme', true);
  useEffect(() => {
    const root = window.document.documentElement;
    root.className = '';

    if (isDarkTheme === true) {
      root.classList.add('dark');
      localStorage.setItem('theme', 'true');
    } else {
      root.classList.add('light');
      localStorage.setItem('theme', 'false');
    }
  }, [isDarkTheme]);

  return [isDarkTheme, toggleTheme];
};

export default useDarkMode;
